/**
 * Header component.
 * @module components/theme/Header/Header
 */

import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Logo, Navigation } from '@plone/volto/components';

import Sidebar from '../../../../components/Sidebar/Sidebar';

/**
 * Header component class.
 * @class Header
 * @extends Component
 */
class Header extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    token: PropTypes.string,
    pathname: PropTypes.string.isRequired,
  };

  /**
   * Default properties.
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    token: null,
  };

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    // Standalone pages (e.g. the Square payment callback, the privacy
    // policy, the terms of service) have no sidebar.
    if (
      ['/payment', '/privacy-policy', '/terms-of-service'].includes(
        this.props.pathname,
      )
    ) {
      return null;
    }

    return this.props.pathname === '' ? (
      <Segment basic className="header-wrapper" role="banner">
        <div className="ui container">
          <div className="logo">
            <Logo />
          </div>
          <div className="header">
            <div />
            <Navigation pathname={this.props.pathname} />
          </div>
        </div>
      </Segment>
    ) : (
      <Sidebar />
    );
  }
}

export default connect((state) => ({
  token: state.userSession.token,
}))(Header);
